module.exports = __webpack_public_path__ + "img/worldpay.4e35aa60.svg";